export default __webpack_public_path__ + "static/media/efficiency-and-transparency-image.7c85060c.png";